import i18n, { type TOptions } from 'i18next';
import type { AxiosError } from 'axios';

// Import types
import { ErrorCodes } from 'types/api/errors';

type BaseErrorData = { errorCode?: ErrorCodes; status: number };

export const getCodeErrorMessage = (code: ErrorCodes | undefined, options: TOptions = {}) => i18n.t([`errors:${code}`, ''], options);

export const getErrorStatus = (status: number | undefined) => {
	switch (status) {
		case 500:
			return i18n.t('error_connection');
		case 502:
			return i18n.t('error_portal_unavailable');
		case 422:
			return i18n.t('error_invalid_data');
		default:
			return i18n.t('common_errors_default_error');
	}
};

export const getErrorData = <T>(error: AxiosError<T> | null) => error?.response?.data ?? ({} as T);

export const getErrorCodeResults = <Data extends BaseErrorData>(error: AxiosError<Data> | null) => {
	const data = getErrorData(error);
	const codeErrorMessage = getCodeErrorMessage(data.errorCode) || getErrorStatus(data.status);
	return { codeErrorMessage, data };
};

export const CUSTOM_ERROR = {
	//Mock error for player parental control
	CUSTOM_PARENTAL_CONTROL_ERROR: {
		response: {
			data: {
				isError: true,
				code: 400,
				message: getCodeErrorMessage(ErrorCodes.BLOCKED_BY_PARENTAL_CONTROL),
				errorCode: ErrorCodes.BLOCKED_BY_PARENTAL_CONTROL
			}
		}
	},
	//Mock error for player end of program in program details
	CUSTOM_END_OF_PROGRAM: {
		response: {
			data: {
				isError: true,
				code: 400,
				message: i18n.t('error_end_of_program'),
				errorCode: 'END_OF_PROGRAM'
			}
		}
	},
	CUSTOM_REQUEST_INVALID_DATA: i18n.t('error_invalid_data'),
	CUSTOM_INVALID_VAT_NUMBER: i18n.t('error_invalid_nip'),
	CHECK_HASH_CUSTOM_CODE: i18n.t('error_hash_status'),
	BROWSER_NOT_SUPPORTED: i18n.t('player_error_browser_not_supported'),
	SHAKA_PLAYER_ERROR_MESSAGE: i18n.t('dictionary:player_error_shaka_player_error_message')
};

// HTTP response status codes
export const HTTP_STATUS_CODES = {
	NOT_ACCEPTABLE: 406
};
